import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=76ea4df1"
import script from "./Unauthorized.vue?vue&type=script&lang=ts"
export * from "./Unauthorized.vue?vue&type=script&lang=ts"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=76ea4df1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports